import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { SupportService } from './service/support.service';
import { SupportFormComponent } from './support-form/support-form.component';
import { SupportHeaderComponent } from './support-header/support-header.component';
import { SupportComponent } from './support.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    UpgradeModule,
    FormsModule
  ],
  declarations: [
    SupportFormComponent,
    SupportHeaderComponent,
    SupportComponent
  ],
  exports: [SupportComponent],
  providers: [SupportService]
})

export class SupportModule {
}
